
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://ngfwjlgmdcoxewihfmlt.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5nZndqbGdtZGNveGV3aWhmbWx0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzcyMzE0MjksImV4cCI6MjA1MjgwNzQyOX0.frDXkKqqLT0S5t-jrSFN_F-P73JQWe3Rjnpjj55PDP4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
